var React = require('react');

function InputBackground (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M2,0.05C1.99,0.01,2.01,0,1.9,0C1.63,0,0.87,0.01,0.8,0.01C0.71,0,0.62,0,0.53,0c-0.08,0-0.16,0-0.24,0\n\tc-0.08,0-0.19-0.01-0.27,0C-0.01,0.01,0,0.03,0,0.04c0,0.1,0,0.12,0,0.16c0,0.04-0.01,0.04,0.1,0.05c0.27,0,0.53,0,0.8,0\n\tc0.05,0,0.23-0.01,0.3-0.01c0.09,0.01,0.18,0.01,0.28,0c0.08,0,0.16,0,0.24,0c0.08,0,0.19,0.01,0.27,0C2,0.23,2,0.21,2,0.2\n\tC2,0.1,2,0.09,2,0.05z"}));
}

InputBackground.defaultProps = {"viewBox":"0 0 2 0.24","preserveAspectRatio":"none"};

module.exports = InputBackground;

InputBackground.default = InputBackground;
